export default __webpack_public_path__ + "static/media/calendarIcon.fcb99986.svg";